import { useEffect, useRef } from "react";
import notificationSoundFile from '../assets/audio/owl-notification-1.mp3';

type Notification = {
  title: string;
  body?: string;
  sound?: boolean;
};

export function useNotificationSound() {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  // create audio element once
  useEffect(() => {
    const audio = new Audio(notificationSoundFile);
    audio.preload = "auto";
    audioRef.current = audio;
  }, []);

  const playNotificationSound = async () => {
    if (!audioRef.current) return;
    try {
      await audioRef.current.play();
    } catch (e) {
      // autoplay was blocked — you can log or show "enable sound" button
      console.warn("Notification sound blocked by browser:", e);
    }
  };

  return { playNotificationSound };
}